import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";

export const ArticlesPreview = () => {
  const { data } = useQuery({
    queryKey: ["articles-public"],
    queryFn: async () => (await api.get("/articles", { params: { published_only: true } })).data,
    retry: 1,
  });
  const articles = (Array.isArray(data) ? data : []).slice(0, 3);

  if (articles.length === 0) return null;

  return (
    <section id="artikel" className="bg-cream py-24 md:py-36 px-6 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <Overline>Artikel</Overline>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-ink">
                Cerita dan tips seputar madu.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <Link
              to="/artikel"
              className="inline-flex items-center gap-2 text-sm font-semibold text-brandRed hover:text-ink transition-colors duration-300"
            >
              Lihat Semua Artikel
              <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.map((a, i) => (
            <Reveal key={a.id} delay={i * 0.1}>
              <Link
                to={`/artikel/${a.slug}`}
                data-testid={`articles-preview-${a.slug}`}
                className="group flex h-full flex-col"
              >
                <div className="overflow-hidden rounded-[1.75rem] arch-top bg-cream-200 mb-5">
                  {a.cover_image ? (
                    <img
                      src={a.cover_image}
                      alt={a.title}
                      className="h-56 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  ) : (
                    <div className="h-56 w-full bg-cream-200" />
                  )}
                </div>
                <h3 className="font-display text-2xl tracking-tight text-ink mb-2 group-hover:text-brandRed transition-colors duration-300">
                  {a.title}
                </h3>
                <p className="text-stone2 leading-relaxed text-[15px] flex-1">{a.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
